// extracted by mini-css-extract-plugin
export var width100 = "y_t d_t";
export var design3Pos = "y_tq d_Y";